import {
  TRANSACTION_PASSWORD_SET_SUCCESS,
  TRANSACTION_PASSWORD_SET_FAILED,
  RESET_TRANSACTION_PASSWORD_SET,
  LOADING_TRANSACTION_PASSWORD_SET,
  NETWORK_ERROR_TRANSACTION_PASSWORD_SET,
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  success: false,
  data: {},
  networkError: "",
  invalidRequest: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_TRANSACTION_PASSWORD_SET: {
      return {
        ...state,
        isLoading: true,
        failed: false,
        success: false,
        invalidRequest: false,
        data: {},
      };
    }
    case TRANSACTION_PASSWORD_SET_FAILED: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case TRANSACTION_PASSWORD_SET_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        data: action.payload,
      };
    }
    case NETWORK_ERROR_TRANSACTION_PASSWORD_SET: {
      return {
        ...state,
        isLoading: false,
        failed: true,
        success: false,
        invalidRequest: false,
        networkError: "Something went wrong!",
        data: {},
      };
    }
    case RESET_TRANSACTION_PASSWORD_SET: {
      return (state = initialState);
    }

    default:
      return state;
  }
};
